module.exports = __webpack_public_path__ + "img/krottenkopf.9846cd7f.jpg";